import React, { useEffect, useState } from "react"
import logoBanner from '../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import './Factory.css'
import FactoryProduct from "../../Components/FactoryProduct/FactoryProduct";
import { urlApiServer, urlApiServerImage } from "../../Config/Config";
import quote from '../../Assests/quote.png'

function Factory() {

    const [factory, setFactory] = useState([]);
    const [factoryCover, setFactoryCover] = useState([]);
    const [selectFabric, setSelectFabric] = useState(false);
    const [factoryInfo, setFactoryInfo] = useState([]);

    const urlGetFactory = `${urlApiServer}factories?populate=*`
    const urlGetFactoryCover = `${urlApiServer}factory-covers?populate=*`

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetFactory, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del fabrica: ', ContactResponse.data);

                        // Asegurar que siempre sea un array
                        if (Array.isArray(ContactResponse.data)) {
                            setFactory(ContactResponse.data.reverse());
                        } else {
                            setFactory([]);
                        }
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setFactory([]); // Asegurar que sea un array vacío en caso de error
            }
        })();

        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetFactoryCover, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del fabrica fondo: ', ContactResponse.data);

                        // Asegurar que siempre sea un array
                        if (Array.isArray(ContactResponse.data)) {
                            setFactoryCover(ContactResponse.data.reverse());
                        } else {
                            setFactoryCover([]);
                        }
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setFactoryCover([]); // Asegurar que sea un array vacío en caso de error
            }
        })();

    }, [urlGetFactory, urlGetFactoryCover]);

    async function handleFactory(e) {
        setSelectFabric(true);

        setFactoryInfo(e);

    }

    const renderFormattedArticleText = (text) => {
        if (!text) return null;

        // Dividir por líneas
        const lines = text.split('\n');

        return lines.map((line, lineIndex) => {
            // Procesar encabezados Markdown
            const headerMatch = line.match(/^(#{1,4})\s(.*)$/);
            if (headerMatch) {
                const [, hashes, content] = headerMatch;
                const level = hashes.length;
                const HeadingTag = `h${level}`;

                return React.createElement(
                    HeadingTag,
                    {
                        key: lineIndex,
                        className: "fabricHeading"
                    },
                    content
                );
            }

            // Procesar citas (líneas que comienzan con >)
            if (line.trim().startsWith('>')) {
                return (
                    <div key={lineIndex} className="quote-container">
                        <img src={quote} alt="quote" className="quote-image" />
                        <span className="quote-text">
                            {line.substring(1).trim()}
                        </span>
                    </div>
                );
            }

            // Procesar listas con guiones
            if (line.trim().startsWith('-')) {
                // Extraer todos los items de la lista
                const listItems = lines
                    .filter(l => l.trim().startsWith('-'))
                    .map(l => {
                        const iconMatch = l.match(/!\[(.*?)\]\((.*?)\)/);
                        const text = l.replace(/^-\s*!\[.*?\]\(.*?\)\s*/, '').trim();
                        return {
                            icon: iconMatch ? iconMatch[2] : null,
                            text: text
                        };
                    });

                const half = Math.ceil(listItems.length / 2);
                const firstColumn = listItems.slice(0, half);
                const secondColumn = listItems.slice(half);

                if (lineIndex === lines.findIndex(l => l.trim().startsWith('-'))) {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <div key={lineIndex} className="two-column-list">
                                <div className="list-column">
                                    {firstColumn.map((item, i) => (
                                        <div key={`first-${i}`} className="list-item">
                                            {item.icon && (
                                                <img
                                                    src={item.icon}
                                                    alt=""
                                                    className="list-icon"
                                                    style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        marginRight: '8px'
                                                    }}
                                                />
                                            )}
                                            <span className="list-text">{item.text}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="list-column">
                                    {secondColumn.map((item, i) => (
                                        <div key={`second-${i}`} className="list-item">
                                            {item.icon && (
                                                <img
                                                    src={item.icon}
                                                    alt=""
                                                    className="list-icon"
                                                    style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        marginRight: '8px'
                                                    }}
                                                />
                                            )}
                                            <span className="list-text">{item.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                }
                return null;
            }

            // Función para procesar negritas (**texto**) y enlaces ([texto](url))
            const processBoldAndLinks = (text) => {
                const parts = [];
                let lastIndex = 0;
                let currentText = text;

                // Procesar negritas
                const boldRegex = /\*\*(.*?)\*\*/g;
                let boldMatch;

                while ((boldMatch = boldRegex.exec(currentText)) !== null) {
                    // Texto antes de la negrita
                    if (boldMatch.index > lastIndex) {
                        parts.push(currentText.substring(lastIndex, boldMatch.index));
                    }
                    // Texto en negrita
                    parts.push(<strong key={`bold-${boldMatch.index}`} className='boldText'>{boldMatch[1]}</strong>);
                    lastIndex = boldRegex.lastIndex;
                }

                // Texto restante después de la última negrita
                if (lastIndex < currentText.length) {
                    parts.push(currentText.substring(lastIndex));
                }

                // Procesar enlaces en el texto resultante
                const processedParts = [];
                lastIndex = 0;

                parts.forEach((part, partIndex) => {
                    if (typeof part === 'string') {
                        const linkRegex = /\[(.*?)\]\((.*?)\)/g;
                        let linkMatch;
                        let linkText = part;
                        let linkLastIndex = 0;

                        while ((linkMatch = linkRegex.exec(linkText)) !== null) {
                            // Texto antes del enlace
                            if (linkMatch.index > linkLastIndex) {
                                processedParts.push(linkText.substring(linkLastIndex, linkMatch.index));
                            }
                            // Enlace
                            processedParts.push(
                                <a
                                    key={`link-${partIndex}-${linkMatch.index}`}
                                    href={linkMatch[2]}
                                    className="article-link"
                                    style={{ textDecoration: 'none' }}
                                >
                                    {linkMatch[1]}
                                </a>
                            );
                            linkLastIndex = linkRegex.lastIndex;
                        }
                        // Texto restante
                        if (linkLastIndex < linkText.length) {
                            processedParts.push(linkText.substring(linkLastIndex));
                        }
                    } else {
                        processedParts.push(part);
                    }
                });

                return processedParts;
            };

            // Si es una línea vacía, añadir un salto de línea
            if (line.trim() === '' && lineIndex < lines.length - 1) {
                return <br key={lineIndex} />;
            }

            // Si no es una lista (ya procesada), renderizar normalmente
            if (!line.trim().startsWith('-')) {
                return (
                    <p className="article-paragraph" key={lineIndex}>
                        {processBoldAndLinks(line)}
                        {lineIndex < lines.length - 1 && <br />}
                    </p>
                );
            }

            return null;
        });
    };

    return (
        <div>
            {(selectFabric === false) ? (
                <>
                    <div className="bannerContainer" style={{ backgroundImage: `url(${urlApiServerImage + factoryCover[0]?.portada?.url})` }}>
                        <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                    </div>
                    <div className="factoryContainer">
                        {
                            factory.map((item, index) => {
                                const isAlternate = index % 2 === 1; // Verdadero para índices impares (1, 3, 5...)
                                return (
                                    <div
                                        className={`factoryItemContainer ${isAlternate ? 'alternateFactoryItem' : ''}`}
                                        key={index}
                                    >
                                        <div className="imageFactoryItem">
                                            <img src={urlApiServerImage + item.imagen.url} alt="imagen" className="imageFactory" />
                                        </div>
                                        <div className={`infoFactoryItem ${isAlternate ? 'alternateInfoFactory' : ''}`}>
                                            <div className="titleFactoryItem">
                                                <p className="titleFactory">{item.titulo}</p>
                                            </div>
                                            <div className="viewProductsButtonFactoryItem" onClick={() => handleFactory(item)}>
                                                <p className="viewProductsButtonFactoryText">VER PRODUCTOS</p>
                                            </div>
                                            <div className="descriptionFactoryItem">
                                                <p className="descriptionFactory">{renderFormattedArticleText(item.descripcion)}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </>
            ) : (
                <FactoryProduct factoryInfo={factoryInfo} onClose={() => setSelectFabric(false)} />
            )}
        </div>
    )
}

export default Factory